import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-lesson-menu.tsx
var LazyCourseLessonMenu = lazy(() => import("./course-lesson-menu-BEilklAf.js").then((n) => n.n).then((module) => ({ default: module.CourseLessonMenu })));
function CourseLessonMenu(props) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-lesson-menu" }),
		children: /* @__PURE__ */ jsx(LazyCourseLessonMenu, { ...props })
	});
}
function CourseLessonMenuContent(props) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-lesson-menu" }),
		children: /* @__PURE__ */ jsx(LazyCourseLessonMenu, { ...props })
	});
}
var useCourseLessonMenuContent = () => {
	return useMemo(() => ({ courseLessonMenu: { component: CourseLessonMenuContent } }), []);
};
//#endregion
export { CourseLessonMenu, useCourseLessonMenuContent };
